import React , { useEffect , useState } from "react";
import {Helmet} from "react-helmet";
import { Switch, Route , useHistory } from "react-router-dom";

import Aos from 'aos'
import {
    ExploreNFTs,
    MyAssets,
    MintNFT,
    Home,
    ItemDetails
} from './pages'

import Head from "./layouts/Head"
import Footer from "./layouts/Footer"
import 'aos/dist/aos.css';
import './assets/css/bootstrap.min.css'
import './assets/css/main.css'
import {onloadAnimation} from "./utils"

import 'bootstrap/dist/js/bootstrap.bundle.min';

const App = () => {

  const history = useHistory()
  const [pathReal , setPathReal] = useState("")

  useEffect(() => {
    Aos.init({
      duration: 1000
      })
  },[])

  useEffect(() => {
    return history.listen((location) => { 
      setPathReal(location.pathname)
    }) 
 },[history]) 

  useEffect(() => {
    onloadAnimation()
  },[pathReal])

  useEffect(() => {
    onloadAnimation()
    window.addEventListener('scroll', onloadAnimation)
  },[])

  return (
    
    	<div className="App">
        <Helmet>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <title>
            NFT Marketplace
          </title>
          <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700" rel="stylesheet" />
          <link rel="stylesheet" type="text/css" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" />
        </Helmet>
        <Head />
  			<Switch>
          <Route path="/" exact component={Home} />
  				<Route path="/explore" component={ExploreNFTs} />
  				<Route path="/my-assets" component={MyAssets} />
          <Route path="/mint" component={MintNFT} />
          <Route path="/item-details" component={ItemDetails} />


  				{/* <Route path="/connectWallet" component={ConnectWallet} /> */}
          {/* <Route path="/contact" component={Contact} /> */}
          {/* <Route path="/createitem" component={CreateItem} /> */}
  				{/* <Route path="/discover" component={Discover} /> */}
          {/* <Route path="/discover-2" component={Discover2} /> */}
          {/* <Route path="/discover-3" component={Discover3} /> */}
          {/* <Route path="/index-blog" component={Blog1} /> */}
          {/* <Route path="/index-blog-with-sidebar" component={Blog2} /> */}
          {/* <Route path="/index-single-blog" component={Detailsx} /> */}
          {/* <Route path="/itemDetails" component={ItemDetails} /> */}
          {/* <Route path="/profile" component={Profile} /> */}
          {/* <Route path="/login" component={Login} /> */}
          {/* <Route path="/signup" component={SignUp} /> */}
  			</Switch>
        <Footer />
	    </div>
    	
    
  );
}

export default App;